const serverConfig = {
  url: process.env.REACT_APP_BACKEND_URL,
  feedbackUrl: process.env.REACT_APP_FEEDBACK_URL,
};

console.log(`Running in ${process.env.NODE_ENV} mode`);
console.log(`Backend URL: ${serverConfig.url}`);
console.log(`Feedback URL: ${serverConfig.feedbackUrl}`);

export default serverConfig;